<template>
  <section v-on:click="sectionClicked" class="imageHeader"
    :class="{imgFull: section.config.imgHeaderDisplayType === 'Full'}">
    <template v-if="section.items && section.items.length > 0">
      <div class="theImg" v-if="section.config.imgHeaderDisplayType === 'Croped'"
        :style="{'background-image': `url(${section.items[0].imageLg})`}"
        ></div>
      <div class="imgFull" v-else>
        <img :src="section.items[0].imageLg">
      </div>
    </template>
    <template v-if="section.title[lang] || section.descriptions[lang]">
      <div class="ihOverlay"></div>
      <div class="ihShadow"></div>
      <div class="sectionHeader">
        <div class="cnt">
          <h4 class="sectionTitle" v-if="section.title[lang]" v-html="section.title[lang]"></h4>
          <p class="sectionDesc" v-if="section.descriptions[lang]">{{section.descriptions[lang]}}</p>
          <a href="#" class="btn" v-if="section.url">Learn More</a>
        </div>
      </div>
    </template>
  </section>
</template>

<script>
export default {
  name: 'home',
  props: ['section'],
  components: {},
  data() {
    return {
      maru1Offset: 40,
      scrolled: false,
      newsIdx: 0,
      ch: null,
      loading: true,

      /**
       * Slider
       *
       */
      sliders: [],
      slideActive: 0,
      sliderpuase: false,
      sliderpuaseForced: false,

      /**
       * Language
       *
       */
      langCode: 'id-id',
      lang: 'id',
    };
  },
  methods: {
    doNothing() {},
    sliderMouseEnter() {
      if (this.sliderpuaseForced) return;
      this.sliderpuase = true;
    },
    sliderMouseLeave() {
      if (this.sliderpuaseForced) return;
      this.sliderpuase = false;
    },
    forceSliderPause() {
      setTimeout(() => {
        this.sliderpuase = !this.sliderpuase;
        this.sliderpuaseForced = this.sliderpuase;
      });
    },
    sectionClicked() {
      if (this.$refs.header) this.$refs.header.headerClicked();
    },
    prevNews() {
      if (this.newsIdx < 1) return;
      this.newsIdx -= 1;
    },
    nextNews() {
      if (this.newsIdx > 2) return;
      this.newsIdx += 1;
    },
    nextNews2() {
      if (this.newsIdx > 3) return;
      this.newsIdx += 1;
    },
    openVideo(item) {
      this.$refs.videoDialog.open(item.media);
    },
  },
  mounted() {
    this.langCode = this.$route.params.lang;
    this.lang = this.langCode === 'id-id' ? 'id' : 'en';
  },
};
</script>

<style scoped lang="scss">
.imageHeader{
  height: 640px;
  position: relative;
  @media (max-width: 1080px) {
    height: 500px;
  }
  @media (max-width: 960px) {
    height: 60vw;
  }
  @media (max-width: 680px) {
    height: 84vw;
  }
  .theImg{
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    position: absolute;
    left: 0; right: 0; top: 0; bottom: 0;
  }
  .ihOverlay{
    position: absolute;
    left: 0; right: 0; top: 0; bottom: 0;
    background-color: rgba(0, 0, 0, .08);
    z-index: 1;
  }
  .ihShadow{
    position: absolute;
    left: 0; top: 0; bottom: 0;
    width: 50%;
    background-image: linear-gradient(to right, rgba(0,0,0,.7) 20%, transparent);
    z-index: 2;
    @media (max-width: 840px) {
      background-image: none;
      background-color: rgba(0, 0, 0, .14);
      width: 100%;
    }
  }
  .sectionHeader{
    position: absolute;
    left: 0; right: 0;
    top: 50%;
    transform: translateY(-50%);
    text-align: left;
    color: #fff;
    z-index: 7;
    @media (max-width: 840px) {
      text-align: center;
    }
    .sectionTitle{
      font-size: 96px;
      font-weight: 600;
      margin: 0;
      text-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
      font-family: 'Bebas Neue', sans-serif;
      letter-spacing: 1px;
      line-height: 1.1;
      color: #FF9100;
      @media (max-width: 1480px) {
        font-size: 84px;
      }
      @media (max-width: 680px) {
        font-size: 48px;
      }
    }
    .sectionDesc{
      color: inherit;
      margin: 0;
      font-size: 24px;
      text-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
      padding: 0;
      color: #FF9100;
      @media (max-width: 1480px) {
        font-size: 20px;
      }
      @media (max-width: 840px) {
        margin: 0 auto;
      }
      @media (max-width: 680px) {
        font-size: 15px;
        line-height: 1.2;
      }
    }
    .btn{
      display: inline-block;
      padding: 10px 30px;
      border: #fff 1px solid;
      background-color: transparent;
      border-radius: 50px;
      font-size: 20px;
      color: #fff;
      font-weight: 400;
      cursor: pointer;
      transition: all .3s ease;
      margin: 20px 0 0;
      @media (max-width: 1480px) {
        font-size: 17px;
      }
      @media (max-width: 680px) {
        padding: 5px 20px;
        font-size: 14px;
        margin-top: 10px;
        background-color: rgba(0, 0, 0, .4);
      }
      &:hover{
        background-color: rgba(0, 0, 0, .2);
        box-shadow: 0 0 4px rgba(0, 0, 0, .1);
      }
    }
  }
  &.imgFull{
    height: auto;
    .imgFull{
      img{
        width: 100%;
        display: block;
      }
    }
  }
}
</style>
